import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/logo_cropped.png'
import _imports_1 from '@/assets/images/file_upload.png'
import _imports_2 from '@/assets/images/site/contact-us.png'
import _imports_3 from '@/assets/images/site/about.png'


const _hoisted_1 = {
  key: 0,
  class: "fixed left-0 right-0 top-0 p-1 header"
}
const _hoisted_2 = { class: "top-left-buttons flex flex-direction-row align-center list-style-type-none" }
const _hoisted_3 = {
  key: 0,
  class: "mt-auto mb-auto"
}
const _hoisted_4 = {
  key: 1,
  class: "lg:ml-3 mt-auto mb-auto"
}
const _hoisted_5 = {
  key: 2,
  class: "lg:ml-3 my-auto"
}
const _hoisted_6 = {
  key: 3,
  class: "pl-1"
}
const _hoisted_7 = { class: "list-style-type-none ml-auto" }
const _hoisted_8 = {
  key: 1,
  class: "fixed left-0 right-0 top-0 p-1 header"
}
const _hoisted_9 = { class: "flex flex-direction-row align-center list-style-type-none" }
const _hoisted_10 = { class: "header-buttons lg:ml-3 mt-2 mb-2" }

import { useConfigStore } from "@/stores/ConfigStore";
import { useAuthStore } from "@/stores/AuthStore";
import { useRouter } from "vue-router";
import HeaderSearchBar from "@/components/user/HeaderSearchBar.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AppHeader',
  setup(__props) {

const ConfigStore = useConfigStore();
const AuthStore = useAuthStore();
const router = useRouter();

const logOut = () => {
  AuthStore.logout();
  router.push("/");
};

ConfigStore.getConfig();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_unref(AuthStore).status)
    ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(AuthStore).role == 'INSTRUCTOR')
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: { name: 'instructor-feed' },
                  class: "inline-block pl-2 pr-2"
                }, {
                  default: _withCtx(() => _cache[0] || (_cache[0] = [
                    _createElementVNode("img", {
                      title: "Home",
                      class: "logo",
                      src: _imports_0
                    }, null, -1)
                  ])),
                  _: 1,
                  __: [0]
                })
              ]))
            : (_unref(AuthStore).role == 'INDUSTRYPRACTITIONER')
              ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                  _createVNode(_component_router_link, {
                    to: { name: 'industry-practitioner-feed' },
                    class: "inline-block pl-2 pr-2"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createElementVNode("img", {
                        title: "Home",
                        class: "logo",
                        src: _imports_0
                      }, null, -1)
                    ])),
                    _: 1,
                    __: [1]
                  })
                ]))
              : (_unref(AuthStore).role == 'ADMIN')
                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                    _createVNode(_component_router_link, {
                      to: { name: 'admin-feed' },
                      class: "admin-logo inline-block pl-2 pr-2 pt-2"
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          title: "Home",
                          src: _imports_0
                        }, null, -1)
                      ])),
                      _: 1,
                      __: [2]
                    })
                  ]))
                : _createCommentVNode("", true),
          (
          _unref(AuthStore).role == 'INDUSTRYPRACTITIONER' ||
          _unref(AuthStore).role == 'INSTRUCTOR'
        )
            ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: { name: 'view-uploads' },
                  class: "my-uploads nav-item nav-link rounded-2"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createElementVNode("img", {
                      src: _imports_1,
                      class: "sidebar-image-large mr-1",
                      alt: "Upload Resources"
                    }, null, -1),
                    _createElementVNode("span", { class: "button-text header-text" }, "My Uploads", -1)
                  ])),
                  _: 1,
                  __: [3]
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: 'contact-us' },
              class: "social-media-button p-1 rounded-2 lg:p-2",
              title: "Contact Us"
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "sidebar-image-large"
                }, null, -1),
                _createElementVNode("span", { class: "button-text" }, "Contact Us", -1)
              ])),
              _: 1,
              __: [4]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: 'about' },
              class: "social-media-button p-1 rounded-2 lg:p-2",
              title: "About Us"
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "sidebar-image-large"
                }, null, -1),
                _createElementVNode("span", { class: "button-text" }, "About Us ", -1)
              ])),
              _: 1,
              __: [5]
            })
          ]),
          _cache[6] || (_cache[6] = _createElementVNode("li", { class: "ml-1" }, null, -1))
        ]),
        (_unref(AuthStore).status)
          ? (_openBlock(), _createBlock(HeaderSearchBar, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("li", {
              class: "nav-item cursor-pointer rounded-2",
              onClick: _withModifiers(logOut, ["prevent"])
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-right-from-bracket",
                class: "log-out-btn header-link",
                title: "Log Out"
              }),
              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "header-text" }, "Log Out", -1))
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("header", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("li", _hoisted_10, [
            _createVNode(_component_router_link, {
              to: { name: 'instructor-feed' },
              class: "nav-item inline-block pl-2 pr-2"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("img", {
                  title: "Home",
                  class: "logo",
                  src: _imports_0
                }, null, -1)
              ])),
              _: 1,
              __: [8]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: 'contact-us' },
              class: "social-media-button p-1 rounded-2 lg:p-2",
              title: "Contact Us"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "sidebar-image-large"
                }, null, -1),
                _createElementVNode("span", { class: "button-text" }, " Contact Us", -1)
              ])),
              _: 1,
              __: [9]
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: { name: 'about' },
              class: "social-media-button p-1 rounded-2 lg:p-2",
              title: "About Us"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createElementVNode("img", {
                  src: _imports_3,
                  class: "sidebar-image-large"
                }, null, -1),
                _createElementVNode("span", { class: "button-text" }, " About Us ", -1)
              ])),
              _: 1,
              __: [10]
            })
          ])
        ])
      ]))
}
}

})